import {
  IssuedPeakAccountStatusType,
  LoadingStatusType,
  PeakPayrollExceptionCode,
  SalaryStatusType,
  TypeComponentNoti,
} from "@/enums/enums";
import { GetErrorMessageByExceptionCode, GetErrorMessageByPayrollExceptionCode } from "@/helper/exceptionCodeHelper";
import salaryHelper from "@/helper/salaryHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { RevenueDeductModel } from "@/model/revenueDeduct/revenueDeductModel";
import { SalaryDetailModel } from "@/model/salary/salaryDetailModel";
import {
  PaymentModel,
  PndItemModel,
  SalaryBookmarkModel,
  SalaryModel,
  SummarySalaryDetailModel,
  SummarySalaryModel,
  SummarySalaryTableViewModel,
} from "@/model/salary/salaryModel";
import { SalaryTableModel } from "@/model/salary/salaryTableModel";
import { SalaryTableViewModel } from "@/model/salary/salaryTableViewModel";
import { WhtCertificateModel } from "@/model/tax/whtCertificateModel";
import router from "@/router/index";
import API from "@/service/Index";
import { ConvertToSalaryDetail, ConvertToSummarySalaryTable } from "@/service/salary/salaryFacade";
import { TranslateResult } from "vue-i18n";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Salary extends VuexModule {
  public createAndUpdateSalaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salaryTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salarySuggestionCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salarySuggestionCode = "";
  public salaryPaidLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salarySSOPaidLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salaryEWFPaidLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateSalaryExpenseLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateSalaryDeletedLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public sendEmailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salaryTableList: Array<SalaryTableModel> = [];
  public headerSalaryTable: any = [];
  public tapsSalaryTable: any = [];
  public SalaryBookmarkModel: any = null;
  public setting: any = null;
  public revenueDeductList: Array<RevenueDeductModel> = [];
  public salaryDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salaryDetail: any = null;
  public logHistoryDetail: any = null;
  public logHistoryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public otherUserList: any = null;
  public otherUserListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public saveBookmarkLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public deletedBookmarkLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public bookmarkListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salaryBookmarkListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public bookmarkList: any = [];
  public paymentBySalaryExpenseId: any = null;
  public paymentBySalaryExpenseIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public paymentByssoExpenseId: any = null;
  public paymentByssoExpenseIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public paymentByEWFExpenseId: any = null;
  public paymentByEWFExpenseIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public autoCalculateWhtList: any = [];
  public autoCalculateWhtListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createSummarySalaryPeriodLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public summarySalaryDetail: SummarySalaryDetailModel | null = null;
  public summarySalaryDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidSummarySalaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public salaryTableForSummarySalary: SalaryDetailModel | null = null;
  public headerSalaryTableForSummarySalary: any = [];
  public salaryTableForSummarySalaryLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public summarySalaryTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public summarySalaryTableList: Array<SummarySalaryModel> = [];
  public headerSummarySalaryTable: any = [];
  public tapsSummarySalaryTable: any = [];
  public whtCertificateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateModel: WhtCertificateModel | null = null;
  public pndItemModel: PndItemModel | null = null;
  public pndItemModelLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateActiveStatus: any = null;
  public voidPaidPaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidExpenseLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getWhtCertificateActiveStatus(): any {
    return this.whtCertificateActiveStatus;
  }
  get getWhtCertificateModel(): WhtCertificateModel | null {
    return this.whtCertificateModel;
  }
  get getWhtCertificateLoadingStatus(): LoadingStatusType {
    return this.whtCertificateLoadingStatus;
  }
  get getSalarySuggestionCodeLoadingStatus(): LoadingStatusType {
    return this.salarySuggestionCodeLoadingStatus;
  }
  get getSalarySuggestionCode(): any {
    return this.salarySuggestionCode;
  }
  get getCreateAndUpdateSalaryLoadingStatus(): LoadingStatusType {
    return this.createAndUpdateSalaryLoadingStatus;
  }
  get getSalaryTableLoadingStatus(): LoadingStatusType {
    return this.salaryTableLoadingStatus;
  }
  get getSalaryTableList(): Array<SalaryTableModel> {
    return this.salaryTableList;
  }
  get getHeaderSalaryTable(): any {
    return this.headerSalaryTable;
  }
  get getTapsSalaryTable(): any {
    return this.tapsSalaryTable;
  }
  get getSalaryDetailLoadingStatus(): LoadingStatusType {
    return this.salaryDetailLoadingStatus;
  }
  get getRevenueDeductList(): Array<RevenueDeductModel> {
    return this.revenueDeductList;
  }
  get getSalaryDetail(): SalaryDetailModel {
    return this.salaryDetail;
  }
  get getSalaryPaidLoadingStatus(): LoadingStatusType {
    return this.salaryPaidLoadingStatus;
  }
  get getSalarySSOPaidLoadingStatus(): LoadingStatusType {
    return this.salarySSOPaidLoadingStatus;
  }
  get getSalaryEWFPaidLoadingStatus(): LoadingStatusType {
    return this.salaryEWFPaidLoadingStatus;
  }
  get getUpdateSalaryExpenseLoadingStatus(): LoadingStatusType {
    return this.updateSalaryExpenseLoadingStatus;
  }
  get getUpdateSalaryDeletedLoadingStatus(): LoadingStatusType {
    return this.updateSalaryDeletedLoadingStatus;
  }
  get getLogHistoryLoadingStatus(): LoadingStatusType {
    return this.logHistoryLoadingStatus;
  }
  get getLogHistoryList(): any {
    return this.logHistoryDetail;
  }
  get getOtherUserList(): any {
    return this.otherUserList;
  }
  get getOtherUserListLoadingStatus(): LoadingStatusType {
    return this.otherUserListLoadingStatus;
  }
  get getSaveBookmarkLoadingStatus(): any {
    return this.saveBookmarkLoadingStatus;
  }
  get getDeletedBookmarkLoadingStatus(): any {
    return this.deletedBookmarkLoadingStatus;
  }
  get getBookmarkListLoadingStatus(): any {
    return this.bookmarkListLoadingStatus;
  }
  get getBookmarkList(): any {
    return this.bookmarkList;
  }
  get getSalaryBookmarkListLoadingStatus(): any {
    return this.salaryBookmarkListLoadingStatus;
  }

  get getPaymentBySalaryExpenseId(): any {
    return this.paymentBySalaryExpenseId;
  }

  get getPaymentBySalaryExpenseIdLoadingStatus(): LoadingStatusType {
    return this.paymentBySalaryExpenseIdLoadingStatus;
  }

  get getPaymentByssoExpenseId(): any {
    return this.paymentByssoExpenseId;
  }

  get getPaymentByssoExpenseIdLoadingStatus(): LoadingStatusType {
    return this.paymentByssoExpenseIdLoadingStatus;
  }

  get getPaymentByEWFExpenseId(): any {
    return this.paymentByEWFExpenseId;
  }

  get getPaymentByEWFExpenseIdLoadingStatus(): LoadingStatusType {
    return this.paymentByEWFExpenseIdLoadingStatus;
  }

  get getAutoCalculateWhtList(): any {
    return this.autoCalculateWhtList;
  }

  get getAutoCalculateWhtListLoadingStatus(): any {
    return this.autoCalculateWhtListLoadingStatus;
  }
  get getCreateSummarySalaryPeriodLoadingStatus(): LoadingStatusType {
    return this.createSummarySalaryPeriodLoadingStatus;
  }

  get getSummarySalaryDetailLoadingStatus(): LoadingStatusType {
    return this.summarySalaryDetailLoadingStatus;
  }

  get getSummarySalaryDetail(): SummarySalaryDetailModel | null {
    return this.summarySalaryDetail;
  }

  get getVoidSummarySalaryLoadingStatus(): LoadingStatusType {
    return this.voidSummarySalaryLoadingStatus;
  }

  get getSalaryTableForSummarySalaryLoadingStatus(): LoadingStatusType {
    return this.salaryTableForSummarySalaryLoadingStatus;
  }

  get getSalaryTableForSummarySalary(): SalaryDetailModel | null {
    return this.salaryTableForSummarySalary;
  }

  get getHeaderSalaryTableForSummarySalary(): any {
    return this.headerSalaryTableForSummarySalary;
  }

  get getSummarySalaryTableLoadingStatus(): LoadingStatusType {
    return this.summarySalaryTableLoadingStatus;
  }

  get getSummarySalaryTableList(): Array<SummarySalaryModel> {
    return this.summarySalaryTableList;
  }

  get getHeaderSummarySalaryTable(): any {
    return this.headerSummarySalaryTable;
  }

  get getTapsSummarySalaryTable(): any {
    return this.tapsSummarySalaryTable;
  }

  get getPndItemModel(): PndItemModel | null {
    return this.pndItemModel;
  }

  get getPndItemModelLoadingStatus(): LoadingStatusType {
    return this.pndItemModelLoadingStatus;
  }

  get getVoidPaidPaymentLoadingStatus(): LoadingStatusType {
    return this.voidPaidPaymentLoadingStatus;
  }

  get getVoidExpenseLoadingStatus(): LoadingStatusType {
    return this.voidExpenseLoadingStatus;
  }

  @Mutation
  public MutationSetCreateAndUpdateSalaryLoadingStatus(loadingStatus: LoadingStatusType) {
    this.createAndUpdateSalaryLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSetSaveBookmarkLoadingStatus(loadingStatus: LoadingStatusType) {
    this.saveBookmarkLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSetDeletedBookmarkLoadingStatus(loadingStatus: LoadingStatusType) {
    this.deletedBookmarkLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationGetBookmarkListLoadingStatus(loadingStatus: LoadingStatusType) {
    this.bookmarkListLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationGetBookmarkList(bookmarkList: any) {
    this.bookmarkList = bookmarkList;
  }
  @Mutation
  public MutationSetSalarySuggestionCodeLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salarySuggestionCodeLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSetSalarySuggestionCode(number: any) {
    this.salarySuggestionCode = number;
  }
  @Mutation
  public MutationSetSalaryTableLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salaryTableLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationGetSalaryTable(input: any) {
    this.tapsSalaryTable = salaryHelper.SetTapsSalaryTable(input.tableView, input.table.count);
    this.headerSalaryTable = salaryHelper.SetHeaderSalaryTable(input.tableView);
    this.salaryTableList = input.table.tableList;
  }
  @Mutation
  public MutationSalaryDetailLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salaryDetailLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSalaryDetail(salaryDetail: SalaryDetailModel) {
    this.salaryDetail = salaryDetail;
  }
  @Mutation
  public MutationPaidSalaryLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salaryPaidLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationLogHistoryDetail(logHistoryDetail: any) {
    this.logHistoryDetail = logHistoryDetail;
  }
  @Mutation
  public MutationPaidSSOSalaryLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salarySSOPaidLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationPaidEWFSalaryLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salaryEWFPaidLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationUpdateSalaryExpenseLoadingStatus(loadingStatus: LoadingStatusType) {
    this.updateSalaryExpenseLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationUpdateSalaryDeletedLoadingStatus(loadingStatus: LoadingStatusType) {
    this.updateSalaryDeletedLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationSendEmailLoadingStatus(loadingStatus: LoadingStatusType) {
    this.sendEmailLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationUserDetailForDisplay(otherUserList: any) {
    this.otherUserList = otherUserList;
  }
  @Mutation
  public MutationUserDetailForDisplayLoadingStatus(loadingStatus: LoadingStatusType) {
    this.otherUserListLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationLogHistoryLoadingStatus(loadingStatus: LoadingStatusType) {
    this.logHistoryLoadingStatus = loadingStatus;
  }

  @Mutation
  public MutationSalaryBookmarkListLoadingStatus(loadingStatus: LoadingStatusType) {
    this.salaryBookmarkListLoadingStatus = loadingStatus;
  }

  @Mutation
  public MutationSetPaymentBySalaryExpenseIdLoadingStatus(status: LoadingStatusType) {
    this.paymentBySalaryExpenseIdLoadingStatus = status;
  }

  @Mutation
  public MutationSetPaymentBySalaryExpenseId(payment: any) {
    this.paymentBySalaryExpenseId = payment;
  }

  @Mutation
  public MutationSetPaymentByssoExpenseIdLoadingStatus(status: LoadingStatusType) {
    this.paymentByssoExpenseIdLoadingStatus = status;
  }

  @Mutation
  public MutationSetPaymentByEWFExpenseIdLoadingStatus(status: LoadingStatusType) {
    this.paymentByEWFExpenseIdLoadingStatus = status;
  }

  @Mutation
  public MutationSetPaymentByssoExpenseId(payment: any) {
    this.paymentByssoExpenseId = payment;
  }

  @Mutation
  public MutationSetPaymentByEWFExpenseId(payment: any) {
    this.paymentByEWFExpenseId = payment;
  }
  @Mutation
  public MutationSetCreateSummarySalaryPeriodLoadingStatus(status: LoadingStatusType) {
    this.createSummarySalaryPeriodLoadingStatus = status;
  }

  @Mutation
  public MutationSummarySalaryDetailLoadingStatus(status: LoadingStatusType) {
    this.summarySalaryDetailLoadingStatus = status;
  }

  @Mutation
  public MutationSummarySalaryDetail(summarySalary: SummarySalaryDetailModel) {
    this.summarySalaryDetail = summarySalary;
  }

  @Mutation
  public MutationGetWhtCertificateModel(whtCertificateModel: WhtCertificateModel) {
    this.whtCertificateModel = whtCertificateModel;
  }

  @Mutation
  public MutationVoidSummarySalaryLoadingStatus(status: LoadingStatusType) {
    this.voidSummarySalaryLoadingStatus = status;
  }

  @Mutation
  public MutationSalaryTableForSummarySalaryLoadingStatus(status: LoadingStatusType) {
    this.salaryTableForSummarySalaryLoadingStatus = status;
  }

  @Mutation
  public MutationSalaryTableForSummarySalary(summarySalary: any) {
    this.headerSalaryTableForSummarySalary = salaryHelper.SetHeaderSalaryTableForSummarySalary();
    this.salaryTableForSummarySalary = summarySalary;
  }

  @Mutation
  public MutationGetSummarySalaryTableLoadingStatus(status: LoadingStatusType) {
    this.summarySalaryTableLoadingStatus = status;
  }

  @Mutation
  public MutationGetSummarySalaryTable(input: any) {
    this.tapsSummarySalaryTable = salaryHelper.SetTapsSummarySalaryTable(input.tableView, input.table.count);
    this.headerSummarySalaryTable = salaryHelper.SetHeaderSummarySalaryTable(input.tableView);
    this.summarySalaryTableList = input.table.summarySalaryTableList;
  }

  @Mutation
  public MutationSetWhtCertificateLoadingStatus(loadingStatus: LoadingStatusType) {
    this.whtCertificateLoadingStatus = loadingStatus;
  }
  @Mutation
  MutationPndItemModelLoadingStatus(status: LoadingStatusType) {
    this.pndItemModelLoadingStatus = status;
  }

  @Mutation
  MutationPndItemModel(pndItemModel: PndItemModel) {
    this.pndItemModel = pndItemModel;
  }

  @Mutation
  public MutationWhtCertificateActiveStatus(status: any) {
    this.whtCertificateActiveStatus = status;
  }

  @Mutation
  public MutationVoidPaidPaymentLoadingStatus(status: any) {
    this.voidPaidPaymentLoadingStatus = status;
  }

  @Mutation
  public MutationVoidExpenseLoadingStatus(status: any) {
    this.voidExpenseLoadingStatus = status;
  }

  @Action
  public DoCreateSalary(input: any) {
    if (this.createAndUpdateSalaryLoadingStatus !== LoadingStatusType.Loading) {
      salaryHelper.SalaryCreateValidated(input.salary);
      const salaryCreateValidated = salaryHelper.CheckSalaryCreateValidated(input.salary);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (salaryCreateValidated) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("MutationSetCreateAndUpdateSalaryLoadingStatus", LoadingStatusType.Loading);
        const salaryCreate: SalaryModel = salaryHelper.ConvertToSalaryCreate(
          input.salary,
          input.salaryStatusType,
          input.isIssuedExpense
        );

        API.SalaryService.DoCreateSalary(salaryCreate).then((resCreateSalary) => {
          if (resCreateSalary.data.responseCode.IsSuccess()) {
            if (input.salaryStatusType == SalaryStatusType.Approved) {
              router.push({
                name: "salaryDetail",
                query: { emi: MerchantId().PeakEncryption(), esi: resCreateSalary.data.salary.id.PeakEncryption() },
              });
            } else if (input.salaryStatusType == SalaryStatusType.Draft) {
              router.push({
                name: "salary",
                query: { emi: MerchantId().PeakEncryption(), stid: "1" },
              });
            } else if (input.salaryStatusType == SalaryStatusType.AwaitApprove) {
              router.push({
                name: "salary",
                query: { emi: MerchantId().PeakEncryption(), stid: "2" },
              });
            }
            inputAlert.alertMessage = i18n.t("Create_Message_Success", {
              message: i18n.t("Salary") + " #" + salaryCreate.number,
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("MutationSetCreateAndUpdateSalaryLoadingStatus", LoadingStatusType.Success);
          } else {
            inputAlert.alertMessage = resCreateSalary.data.exception.content
              ? GetErrorMessageByPayrollExceptionCode(resCreateSalary.data.exception)
              : GetErrorMessageByExceptionCode(resCreateSalary.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationSetCreateAndUpdateSalaryLoadingStatus", LoadingStatusType.None);
          }
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

          this.context.dispatch("Loading/IsLoading", false, { root: true });
        });
      } else {
        if (input.salary.dueDate.isValidateDateError) {
          inputAlert.alertMessage = i18n.t("Cant_Set_Duedate_Before_Transaction_Date");
        } else if (input.salary.toDate.isValidateDateError) {
          inputAlert.alertMessage = i18n.t("Cant_Set_Fromdate_Before_Todate");
        } else {
          inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        }
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      return salaryCreateValidated;
    }
  }
  @Action
  public DoSaveBookmark(input: any) {
    if (this.saveBookmarkLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetSaveBookmarkLoadingStatus", LoadingStatusType.Loading);
      const salaryBookmarkModel: SalaryBookmarkModel = salaryHelper.ConvertToSalaryBookmarkModel(
        input.salaryCreate,
        input
      );
      API.SalaryService.DoCreateBookmark(salaryBookmarkModel).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetSaveBookmarkLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.None);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoDeletedBookmark(bookmarkId: number) {
    if (this.deletedBookmarkLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetDeletedBookmarkLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoDeletedBookmark(bookmarkId).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSetDeletedBookmarkLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.None);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoGetBookmarkList() {
    if (this.bookmarkListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetBookmarkList().then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationGetBookmarkList", res.data.bookmarkList);
        }
        this.context.commit("MutationGetBookmarkListLoadingStatus", LoadingStatusType.Success);

        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoEditSalary(input: any) {
    if (this.createAndUpdateSalaryLoadingStatus !== LoadingStatusType.Loading) {
      salaryHelper.SalaryCreateValidated(input.salary);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      const salaryCreateValidated = salaryHelper.CheckSalaryCreateValidated(input.salary);
      if (salaryCreateValidated) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("MutationSetCreateAndUpdateSalaryLoadingStatus", LoadingStatusType.Loading);
        const salaryCreate: SalaryModel = salaryHelper.ConvertToSalaryCreate(
          input.salary,
          input.salaryStatusType,
          input.isIssuedExpense
        );
        API.SalaryService.DoEditSalary(salaryCreate).then((resCreateSalary) => {
          if (resCreateSalary.data.responseCode.IsSuccess()) {
            if (input.salaryStatusType == SalaryStatusType.Approved) {
              router.push({
                name: "salaryDetail",
                query: { emi: MerchantId().PeakEncryption(), esi: input.salary.id.PeakEncryption() },
              });
            } else if (input.salaryStatusType == SalaryStatusType.Draft) {
              router.push({
                name: "salary",
                query: { emi: MerchantId().PeakEncryption(), stid: "1" },
              });
            } else if (input.salaryStatusType == SalaryStatusType.AwaitApprove) {
              router.push({
                name: "salary",
                query: { emi: MerchantId().PeakEncryption(), stid: "2" },
              });
            }
            inputAlert.alertMessage = i18n.t("Update_Message_Success", {
              message: i18n.t("Salary") + " #" + salaryCreate.number,
            });
            inputAlert.typeMessage = TypeComponentNoti.Success;
            this.context.commit("MutationSetCreateAndUpdateSalaryLoadingStatus", LoadingStatusType.Success);
          } else {
            inputAlert.alertMessage = GetErrorMessageByPayrollExceptionCode(resCreateSalary.data.exception);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationSetCreateAndUpdateSalaryLoadingStatus", LoadingStatusType.None);
          }
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });

          this.context.dispatch("Loading/IsLoading", false, { root: true });
        });
      } else {
        if (input.salary.dueDate.isValidateDateError) {
          inputAlert.alertMessage = i18n.t("Cant_Set_Duedate_Before_Transaction_Date");
        } else {
          inputAlert.alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        }
        inputAlert.typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      return salaryCreateValidated;
    }
  }
  @Action
  public DoGetSalarySuggestionCode(date: string) {
    if (this.salarySuggestionCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetSalarySuggestionCodeLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetSalarySuggestionCode(date).then((resGetSalarySuggestionCode) => {
        if (resGetSalarySuggestionCode.status.IsSuccess()) {
          this.context.commit("MutationSetSalarySuggestionCode", resGetSalarySuggestionCode.data.code);
        } else {
          this.context.commit("MutationSetSalarySuggestionCode", "");
        }
        this.context.commit("MutationSetSalarySuggestionCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetSalaryTable(tableView: SalaryTableViewModel) {
    if (this.salaryTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetSalaryTableLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetSalaryTable(tableView).then((resSalaryTable) => {
        if (resSalaryTable.status.IsSuccess()) {
          this.context.commit("MutationGetSalaryTable", {
            tableView: tableView,
            table: resSalaryTable.data.table,
          });
        }
        this.context.commit("MutationSetSalaryTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetUserDetailForDisplay(userIdList: any) {
    if (this.otherUserListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationUserDetailForDisplayLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoGetUserDetailForDisplay(userIdList).then((res) => {
        this.context.commit("MutationUserDetailForDisplay", res.userDetailList);
        this.context.commit("MutationUserDetailForDisplayLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetSalaryDetail(salaryId: number): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.salaryDetailLoadingStatus !== LoadingStatusType.Loading) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.Loading);

        API.SalaryService.DoGetSalaryDetail(salaryId).then((resSalaryDetail) => {
          if (resSalaryDetail.status.IsSuccess()) {
            const detail = ConvertToSalaryDetail(resSalaryDetail.data.detail);
            this.context.commit("MutationSalaryDetail", detail);
          }

          this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });

          resolve(true);
        });
      }
    });
  }
  @Action
  public DoGetLogHistoryDetail(input: any) {
    if (this.logHistoryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationLogHistoryLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetLogHistoryDetail(input).then((res) => {
        if (res) {
          this.context.commit("MutationLogHistoryDetail", res.data.logs);
        }

        this.context.commit("MutationLogHistoryLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public async DoUpdateSalaryPaid(input: { salaryId: number; payment: PaymentModel; number: string }) {
    if (this.updateSalaryExpenseLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.Loading);

      let alertMessage: TranslateResult | string = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.Success;
      let isValidateSuccess = false;
      let isIssuedExpenseSuccess = false;
      let isSalaryPaidSuccess = false;
      let insertedExpenseId = 0;
      let insertedExpenseNumber = "";

      await this.context.dispatch("DoGetSalaryDetail", input.salaryId);
      const salaryDetail: SalaryDetailModel = this.context.getters.getSalaryDetail;

      const resValidate: any = await API.SalaryService.DoValidateBeforeUpdateSalaryPaid(input);

      if (resValidate.data.responseCode.IsSuccess()) {
        isValidateSuccess = true;
      } else if (resValidate.data.responseCode.IsSeeOther()) {
        typeMessage = TypeComponentNoti.Error;
        alertMessage = GetErrorMessageByPayrollExceptionCode(resValidate.data.exception);

        this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
      }

      if (isValidateSuccess) {
        switch (salaryDetail.issuedSalaryExpenseStatusType) {
          case IssuedPeakAccountStatusType.None: {
            const resCreateExpense = await API.ExpenseService.DoCreateExpenseFromPayRun({
              salary: salaryDetail,
              payment: input.payment,
              issuedSalaryExpenseStatusType: IssuedPeakAccountStatusType.IssuedWhenPaidPayment,
              isUpdateTimezone: false,
            });

            if (resCreateExpense.data.responseCode.IsSuccess()) {
              isIssuedExpenseSuccess = true;
              insertedExpenseId = resCreateExpense.data.insertedTransaction.id;
              insertedExpenseNumber = resCreateExpense.data.insertedTransaction.number;
            } else if (resCreateExpense.data.responseCode.IsSeeOther()) {
              typeMessage = TypeComponentNoti.Error;
              alertMessage = GetErrorMessageByExceptionCode(resCreateExpense.data.exception);

              this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
            }
            break;
          }
          case IssuedPeakAccountStatusType.IssuedWhenCreatedSalary: {
            const resPaidExpense = await API.ExpenseService.DoPaidExpenseFromPayroll({
              expenseId: salaryDetail.salaryExpenseId,
              payment: input.payment,
            });

            if (resPaidExpense.data.responseCode.IsSuccess()) {
              isIssuedExpenseSuccess = true;
            } else if (resPaidExpense.data.responseCode.IsSeeOther()) {
              typeMessage = TypeComponentNoti.Error;
              alertMessage = GetErrorMessageByExceptionCode(resPaidExpense.data.exception);

              this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
            }
            break;
          }
        }
      }

      if (isIssuedExpenseSuccess) {
        const resSalaryPaid: any = await API.SalaryService.DoUpdateSalaryPaid({
          salaryId: salaryDetail.id,
          insertedExpenseId: insertedExpenseId,
          insertedExpenseNumber: insertedExpenseNumber,
          payment: input.payment,
        });

        if (resSalaryPaid.data.responseCode.IsSuccess()) {
          isSalaryPaidSuccess = true;
        } else if (resSalaryPaid.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByPayrollExceptionCode(resSalaryPaid.data.exception);

          this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isValidateSuccess && isIssuedExpenseSuccess && isSalaryPaidSuccess) {
        typeMessage = TypeComponentNoti.Success;
        alertMessage = i18n.t("Paid_Message_Success", {
          message: `${i18n.t("Salary")} #${input.number}`,
        });

        this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
      }

      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch("Alert/SetAlertMessage", { alertMessage, typeMessage }, { root: true });
    }
  }
  @Action
  public async DoUpdateSalarySSOPaid(input: { salaryId: number; payment: PaymentModel; number: string }) {
    if (this.salarySSOPaidLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationPaidSSOSalaryLoadingStatus", LoadingStatusType.Loading);

      let alertMessage: TranslateResult | string = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.Success;
      let isValidateSuccess = false;
      let isIssuedExpenseSuccess = false;
      let isSalaryPaidSuccess = false;
      let insertedExpenseId = 0;
      let insertedExpenseNumber = "";

      await this.context.dispatch("DoGetSalaryDetail", input.salaryId);
      const salaryDetail: SalaryDetailModel = this.context.getters.getSalaryDetail;

      const resValidate: any = await API.SalaryService.DoValidateBeforeUpdateSalarySSOPaid(input);

      if (resValidate.data.responseCode.IsSuccess()) {
        isValidateSuccess = true;
      } else if (resValidate.data.responseCode.IsSeeOther()) {
        typeMessage = TypeComponentNoti.Error;
        alertMessage = GetErrorMessageByPayrollExceptionCode(resValidate.data.exception);

        this.context.commit("MutationPaidSSOSalaryLoadingStatus", LoadingStatusType.None);
      }

      if (isValidateSuccess) {
        const resCreateExpense = await API.ExpenseService.DoCreateExpenseFromSSO({
          salary: salaryDetail,
          payment: input.payment,
        });

        if (resCreateExpense.data.responseCode.IsSuccess()) {
          isIssuedExpenseSuccess = true;
          insertedExpenseId = resCreateExpense.data.insertedTransaction.id;
          insertedExpenseNumber = resCreateExpense.data.insertedTransaction.number;
        } else if (resCreateExpense.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByExceptionCode(resCreateExpense.data.exception);

          this.context.commit("MutationPaidSSOSalaryLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isIssuedExpenseSuccess) {
        const resSalaryPaid: any = await API.SalaryService.DoUpdateSalarySSOPaid({
          salaryId: salaryDetail.id,
          insertedExpenseId: insertedExpenseId,
          insertedExpenseNumber: insertedExpenseNumber,
          payment: input.payment,
        });

        if (resSalaryPaid.data.responseCode.IsSuccess()) {
          isSalaryPaidSuccess = true;
        } else if (resSalaryPaid.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByPayrollExceptionCode(resSalaryPaid.data.exception);

          this.context.commit("MutationPaidSSOSalaryLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isValidateSuccess && isIssuedExpenseSuccess && isSalaryPaidSuccess) {
        typeMessage = TypeComponentNoti.Success;
        alertMessage = i18n.t("Paid_Message_Success", {
          message: `${i18n.t("SSO")} #${input.number}`,
        });

        this.context.commit("MutationPaidSSOSalaryLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
      }

      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch("Alert/SetAlertMessage", { alertMessage, typeMessage }, { root: true });
    }
  }
  @Action
  public async DoUpdateSalaryEWFPaid(input: {
    salaryId: number;
    payment: PaymentModel;
    number: string;
    revenueDeductList: Array<RevenueDeductModel>;
  }) {
    if (this.salaryEWFPaidLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationPaidEWFSalaryLoadingStatus", LoadingStatusType.Loading);

      let alertMessage: TranslateResult | string = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.Success;
      let isValidateSuccess = false;
      let isIssuedExpenseSuccess = false;
      let isSalaryPaidSuccess = false;
      let insertedExpenseId = 0;
      let insertedExpenseNumber = "";

      const salaryDetail: SalaryDetailModel = this.context.getters.getSalaryDetail;
      const revenueDeductList: Array<RevenueDeductModel> = input.revenueDeductList;

      const resValidate: any = await API.SalaryService.DoValidateBeforeUpdateSalaryEWFPaid(input);

      if (resValidate.data.responseCode.IsSuccess()) {
        isValidateSuccess = true;
      } else if (resValidate.data.responseCode.IsSeeOther()) {
        typeMessage = TypeComponentNoti.Error;
        alertMessage = GetErrorMessageByPayrollExceptionCode(resValidate.data.exception);

        this.context.commit("MutationPaidEWFSalaryLoadingStatus", LoadingStatusType.None);
      }

      if (isValidateSuccess) {
        const resCreateExpense = await API.ExpenseService.DoCreateExpenseFromEWF({
          salary: salaryHelper.ConvertToEWFCreateModel(salaryDetail, revenueDeductList),
          payment: input.payment,
        });

        if (resCreateExpense.data.responseCode.IsSuccess()) {
          isIssuedExpenseSuccess = true;
          insertedExpenseId = resCreateExpense.data.insertedTransaction.id;
          insertedExpenseNumber = resCreateExpense.data.insertedTransaction.number;
        } else if (resCreateExpense.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByExceptionCode(resCreateExpense.data.exception);

          this.context.commit("MutationPaidEWFSalaryLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isIssuedExpenseSuccess) {
        const resSalaryPaid: any = await API.SalaryService.DoUpdateSalaryEWFPaid({
          salaryId: salaryDetail.id,
          insertedExpenseId: insertedExpenseId,
          insertedExpenseNumber: insertedExpenseNumber,
          payment: input.payment,
        });

        if (resSalaryPaid.data.responseCode.IsSuccess()) {
          isSalaryPaidSuccess = true;
        } else if (resSalaryPaid.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByPayrollExceptionCode(resSalaryPaid.data.exception);

          this.context.commit("MutationPaidEWFSalaryLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isValidateSuccess && isIssuedExpenseSuccess && isSalaryPaidSuccess) {
        typeMessage = TypeComponentNoti.Success;
        alertMessage = i18n.t("Paid_Message_Success", {
          message: `${i18n.t("EWF_Short")} #${input.number}`,
        });

        this.context.commit("MutationPaidEWFSalaryLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
      }

      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch("Alert/SetAlertMessage", { alertMessage, typeMessage }, { root: true });
    }
  }
  @Action
  public async DoUpdateSalaryExpense(input: {
    salaryId: number;
    number: string;
    revenueDeductList: Array<RevenueDeductModel>;
  }) {
    if (this.updateSalaryExpenseLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.Loading);

      let alertMessage: TranslateResult | string = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.Success;
      let isValidateSuccess = false;
      let isIssuedExpenseSuccess = false;
      let isSalaryPaidSuccess = false;
      let insertedExpenseId = 0;
      let insertedExpenseNumber = "";

      await this.context.dispatch("DoGetSalaryDetail", input.salaryId);
      const salaryDetail: SalaryDetailModel = this.context.getters.getSalaryDetail;
      const revenueDeductList: Array<RevenueDeductModel> = input.revenueDeductList;

      const resValidate: any = await API.SalaryService.DoValidateBeforeUpdateSalaryExpense({
        salaryId: input.salaryId,
        payment: null,
      });

      if (resValidate.data.responseCode.IsSuccess()) {
        isValidateSuccess = true;
      } else if (resValidate.data.responseCode.IsSeeOther()) {
        typeMessage = TypeComponentNoti.Error;
        alertMessage = GetErrorMessageByPayrollExceptionCode(resValidate.data.exception);

        this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
      }

      if (isValidateSuccess) {
        const resCreateExpense = await API.ExpenseService.DoCreateExpenseFromPayRun({
          salary: salaryHelper.ConvertToEWFCreateModel(salaryDetail, revenueDeductList),
          payment: null,
          issuedSalaryExpenseStatusType: IssuedPeakAccountStatusType.IssuedWhenCreatedSalary,
          isUpdateTimezone: true,
        });

        if (resCreateExpense.data.responseCode.IsSuccess()) {
          isIssuedExpenseSuccess = true;
          insertedExpenseId = resCreateExpense.data.insertedTransaction.id;
          insertedExpenseNumber = resCreateExpense.data.insertedTransaction.number;
        } else if (resCreateExpense.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByExceptionCode(resCreateExpense.data.exception);

          this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isIssuedExpenseSuccess) {
        const resSalaryPaid: any = await API.SalaryService.DoUpdateSalaryExpense({
          salaryId: input.salaryId,
          insertedExpenseId: insertedExpenseId,
          insertedExpenseNumber: insertedExpenseNumber,
        });

        if (resSalaryPaid.data.responseCode.IsSuccess()) {
          isSalaryPaidSuccess = true;
        } else if (resSalaryPaid.data.responseCode.IsSeeOther()) {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetErrorMessageByPayrollExceptionCode(resSalaryPaid.data.exception);

          this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.None);
        }
      }

      if (isValidateSuccess && isIssuedExpenseSuccess && isSalaryPaidSuccess) {
        typeMessage = TypeComponentNoti.Success;
        alertMessage = `${i18n.t("Record_accrued")}${i18n.t("Salary")} #${input.number} ${i18n.t("Success")}`;

        this.context.commit("MutationUpdateSalaryExpenseLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
      }

      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch("Alert/SetAlertMessage", { alertMessage, typeMessage }, { root: true });
    }
  }
  @Action
  public DoUpdateSalaryDeleted(salary: any) {
    if (this.updateSalaryDeletedLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationUpdateSalaryDeletedLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.SalaryService.DoUpdateSalaryDeleted(salary.salaryId).then((resUpdateSalaryDeleted) => {
        if (resUpdateSalaryDeleted.data.responseCode.IsSuccess()) {
          router.push({
            name: "salary",
            query: { emi: MerchantId().PeakEncryption(), stid: "8" },
          });
          inputAlert.alertMessage = i18n.t("Remove_Message_Success", {
            message: i18n.t("Salary") + " #" + salary.number,
          });
          this.context.commit("MutationUpdateSalaryDeletedLoadingStatus", LoadingStatusType.Success);
        } else if (resUpdateSalaryDeleted.data.responseCode.IsSeeOther()) {
          inputAlert.alertMessage = resUpdateSalaryDeleted.data.exception.isPeakDefaultException
            ? GetErrorMessageByExceptionCode(resUpdateSalaryDeleted.data.exception)
            : GetErrorMessageByPayrollExceptionCode(resUpdateSalaryDeleted.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationUpdateSalaryDeletedLoadingStatus", LoadingStatusType.None);
        } else {
          inputAlert.alertMessage = GetErrorMessageByExceptionCode(resUpdateSalaryDeleted.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationUpdateSalaryDeletedLoadingStatus", LoadingStatusType.None);
        }
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetSalaryInBookmark(bookmarkId: number) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("MutationSalaryBookmarkListLoadingStatus", LoadingStatusType.Loading);
    API.SalaryService.DoGetSalaryInBookmark(bookmarkId).then((resSalaryDetail) => {
      if (resSalaryDetail.status.IsSuccess()) {
        const detail = ConvertToSalaryDetail(resSalaryDetail.data.detail);
        this.context.commit("MutationSalaryDetail", detail);
        this.context.commit("MutationSalaryBookmarkListLoadingStatus", LoadingStatusType.Success);
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  public DoSendSlipEmail(input: any) {
    if (this.updateSalaryDeletedLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      let alertMessage: any = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.success;
      API.SalaryService.DoSendSlipEmail(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          alertMessage = i18n.t("send_email_succeed");
          typeMessage = TypeComponentNoti.Success;
        } else {
          alertMessage = GetErrorMessageByPayrollExceptionCode(res.data.exception);
          typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationDeleteEmployeeLoadingStatus", LoadingStatusType.None);
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          },
          { root: true }
        );
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoSendWhtCertificateEmail(input: any) {
    if (this.sendEmailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSendEmailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      let alertMessage: any = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.success;
      API.SalaryService.DoSendWhtCertificateEmail(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          alertMessage = i18n.t("send_email_succeed");
          typeMessage = TypeComponentNoti.Success;
        } else {
          alertMessage = i18n.t("Send_Email_Failed");
          typeMessage = TypeComponentNoti.Error;
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          },
          { root: true }
        );
        this.context.commit("MutationSendEmailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetPaymentBySalaryExpenseId(transactionId: number) {
    if (this.paymentBySalaryExpenseIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetPaymentBySalaryExpenseIdLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetPaymentAndReferenceJournalDetailByInvoice(transactionId).then((res) => {
        this.context.commit(
          "MutationSetPaymentBySalaryExpenseId",
          salaryHelper.ConvertToPaymentAndReferenceJournalDetail(res.data.payment, transactionId)
        );
        this.context.commit("MutationSetPaymentBySalaryExpenseIdLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPaymentByssoExpenseId(transactionId: number) {
    if (this.paymentByssoExpenseIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetPaymentByssoExpenseIdLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetPaymentAndReferenceJournalDetailByInvoice(transactionId).then((res) => {
        this.context.commit(
          "MutationSetPaymentByssoExpenseId",
          salaryHelper.ConvertToPaymentAndReferenceJournalDetail(res.data.payment, transactionId)
        );
        this.context.commit("MutationSetPaymentByssoExpenseIdLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPaymentByEWFExpenseId(transactionId: number) {
    if (this.paymentByEWFExpenseIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetPaymentByEWFExpenseIdLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetPaymentAndReferenceJournalDetailByInvoice(transactionId).then((res) => {
        this.context.commit(
          "MutationSetPaymentByEWFExpenseId",
          salaryHelper.ConvertToPaymentAndReferenceJournalDetail(res.data.payment, transactionId)
        );
        this.context.commit("MutationSetPaymentByEWFExpenseIdLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoCreateSummarySalaryPeriod(input: any) {
    if (this.createSummarySalaryPeriodLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetCreateSummarySalaryPeriodLoadingStatus", LoadingStatusType.Loading);

      let alertMessage: any = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.success;

      API.SalaryService.DoCreateSummarySalaryPeriod(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.summarySalaryId > 0) {
            alertMessage = i18n.t("Alert_Create_Salary_Summary_Success", { msg: res.data.summarySalaryCode });
            typeMessage = TypeComponentNoti.Success;
            router.push({
              name: "salarySummaryDetail",
              query: { emi: MerchantId().PeakEncryption(), esi: res.data.summarySalaryId.PeakEncryption() },
            });
          } else {
            alertMessage = i18n.t("Alert_Create_Salary_Summary_NoneHaveData");
            typeMessage = TypeComponentNoti.Error;
          }
        } else {
          alertMessage = GetErrorMessageByPayrollExceptionCode(res.data.exception);
          typeMessage = TypeComponentNoti.Error;
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          },
          { root: true }
        );
        this.context.commit("MutationSetCreateSummarySalaryPeriodLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetSummarySalaryDetail(summarySalaryId: number) {
    if (this.summarySalaryDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSummarySalaryDetailLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetSummarySalaryDetail(summarySalaryId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const summarySalaryDetail = salaryHelper.ConvertToSummarySalaryDetail(res.data.summarySalaryDetailModel);
          this.context.commit("MutationSummarySalaryDetail", summarySalaryDetail);
        }
        this.context.commit("MutationSummarySalaryDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoVoidSummarySalary(input: any) {
    if (this.voidSummarySalaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationVoidSummarySalaryLoadingStatus", LoadingStatusType.Loading);

      let alertMessage: any = "";
      let typeMessage: TypeComponentNoti = TypeComponentNoti.success;

      API.SalaryService.DoVoidSummarySalary(input.summarySalaryId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          alertMessage = i18n.t("Alert_Void_Salary_Summary_Success", { msg: input.summarySalaryCode });
          typeMessage = TypeComponentNoti.Success;
          router.push({
            name: "salarySummary",
            query: { emi: MerchantId().PeakEncryption() },
          });
        } else {
          alertMessage = GetErrorMessageByPayrollExceptionCode(res.data.exception);
          typeMessage = TypeComponentNoti.Error;
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          },
          { root: true }
        );
        this.context.commit("MutationVoidSummarySalaryLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetSalaryTableForSummarySalary(summarySalaryId: number) {
    if (this.salaryTableForSummarySalaryLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSalaryTableForSummarySalaryLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetSalaryTableForSummarySalary(summarySalaryId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSalaryTableForSummarySalary", res.data.salaryDetailModelList);
        }
        this.context.commit("MutationSalaryTableForSummarySalaryLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetWhtCertificate(input: any) {
    if (this.whtCertificateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetWhtCertificateLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetWhtCertificateById(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const whtCertificateModel = salaryHelper.CovertToWhtCertificateModel(res.data.whtCertificateModel);
          this.context.commit("MutationGetWhtCertificateModel", whtCertificateModel);
        } else {
          this.context.commit("Statement/MutationSetStatementIsLogin", false, { root: true });
        }
        this.context.commit("MutationSetWhtCertificateLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetWhtCertificateByPasscode(input: any) {
    if (this.whtCertificateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetWhtCertificateLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetWhtCertificateByPasscode(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const whtCertificateModel = salaryHelper.CovertToWhtCertificateModel(res.data.whtCertificateModel);
          this.context.commit("MutationGetWhtCertificateModel", whtCertificateModel);
          this.context.commit("MutationSetWhtCertificateLoadingStatus", LoadingStatusType.Success);
        } else {
          if (res.data.exception.code == PeakPayrollExceptionCode.WhtCertificateVoid) {
            this.context.commit("MutationWhtCertificateActiveStatus", "Text_Alert_Passcode_NullForWhtCertificate");
          } else {
            this.context.commit("MutationWhtCertificateActiveStatus", "Wrong_OTP_Code");
          }
          this.context.commit("MutationSetWhtCertificateLoadingStatus", LoadingStatusType.Fail);
        }
      });
    }
  }

  @Action
  public DoGetSummarySalaryTable(tableView: SummarySalaryTableViewModel) {
    if (this.summarySalaryTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationGetSummarySalaryTableLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetSummarySalaryTable(tableView).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationGetSummarySalaryTable", {
            tableView: tableView,
            table: ConvertToSummarySalaryTable(res.data.table),
          });
        }
        this.context.commit("MutationGetSummarySalaryTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPndItemModel(summarySalaryId: number) {
    if (this.pndItemModelLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationPndItemModelLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoGetPndItemModel(summarySalaryId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pndItemModel = salaryHelper.CovertToPndItemModel(res.data.pndItemModel);
          this.context.commit("MutationPndItemModel", pndItemModel);
        }
        this.context.commit("MutationPndItemModelLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoVoidPaidPayment(paymentGroupId: number) {
    if (this.voidPaidPaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationVoidPaidPaymentLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoVoidPaidPayment(paymentGroupId).then((res) => {
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        if (res.data.responseCode.IsSuccess()) {
          inputAlert.alertMessage = i18n.t("Voided_Payment_Success");
        } else {
          inputAlert.alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.error;
        }
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
        this.context.commit("MutationVoidPaidPaymentLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      });
    }
  }

  @Action
  public DoVoidPaidExpense(transactionId: number) {
    if (this.voidExpenseLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationVoidExpenseLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoVoidInvoice(transactionId).then((res) => {
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        if (res.data.responseCode.IsSuccess()) {
          inputAlert.alertMessage = i18n.t("Voided_Expense_Success");
        } else {
          inputAlert.alertMessage = GetErrorMessageByExceptionCode(res.data.exception);
          inputAlert.typeMessage = TypeComponentNoti.error;
        }
        this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
        this.context.commit("MutationVoidExpenseLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
      });
    }
  }

  @Action
  public DoRecheckDataSalaryExpense(salaryId: number): Promise<boolean> {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    return new Promise((resolve, reject) => {
      API.SalaryService.DoRecheckDataSalaryExpense(salaryId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(true);
        } else {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: GetErrorMessageByPayrollExceptionCode(res.data.exception),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          resolve(true);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    });
  }

  @Action
  public DoRecheckDataSSOExpense(salaryId: number): Promise<boolean> {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    return new Promise((resolve, reject) => {
      API.SalaryService.DoRecheckDataSSOExpense(salaryId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(true);
        } else {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: GetErrorMessageByPayrollExceptionCode(res.data.exception),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          resolve(true);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    });
  }
  @Action
  public DoRecheckDataEWFExpense(salaryId: number): Promise<boolean> {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    return new Promise((resolve, reject) => {
      API.SalaryService.DoRecheckDataEWFExpense(salaryId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(true);
        } else {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: GetErrorMessageByPayrollExceptionCode(res.data.exception),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          resolve(true);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    });
  }
  @Action
  public DoReInsertSalaryActive(salaryId: number): Promise<boolean> {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    return new Promise((resolve, reject) => {
      API.SalaryService.DoReInsertSalaryActive(salaryId).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(true);
        } else {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: GetErrorMessageByPayrollExceptionCode(res.data.exception),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          resolve(true);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    });
  }
}
